import { render, staticRenderFns } from "./PageSingle.vue?vue&type=template&id=57882415&"
import script from "./PageSingle.vue?vue&type=script&lang=js&"
export * from "./PageSingle.vue?vue&type=script&lang=js&"
import style0 from "./PageSingle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports